export const MAX_FIELD_COUNT_EXPORT = 9;

export const MAX_FIELD_WARNING_COUNT_EXPORT = 9;
